import React from "react";
import { Pie } from "@ant-design/charts";

interface FiveGCompatibilityPieProps {
  data: { compatible: number; incompatible: number };
}

export const FiveGCompatibilityPie: React.FC<FiveGCompatibilityPieProps> = ({
  data,
}) => {
  if (data.compatible === 0 && data.incompatible === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const config = {
    data: [
      { type: "5G Uyumlu", value: data.compatible },
      { type: "5G Uyumsuz", value: data.incompatible },
    ],
    angleField: "value",
    colorField: "type",
    color: ["#66bb6a", "#ef5350"],
    paddingRight: 80,
    label: {
      text: "value",
      position: "outside" as const,
    },
    legend: {
      color: {
        title: true,
        position: "left" as const,
        rowPadding: 0,
      },
    },
  };

  return <Pie {...config} />;
};
